<template>
    <div>
        <main id="content" role="main">
            <!-- Login Form -->
            <div class="container space-2">
                <form @submit="submit_form" class="js-validate w-md-75 w-lg-50 mx-md-auto">
                    <!-- Title -->
                    <div class="mb-7">
                        <h1 class="h3 text-primary font-weight-normal mb-0">Bienvenue sur <span class="font-weight-semi-bold">ResolveNeed</span></h1>
                        <p>Remplissez ce formulaire pour commencer.</p>
                    </div>
                    <!-- End Title -->

                    <!-- Form Group -->
                    <div class="js-form-message form-group">
                        <label class="form-label" for="signinSrEmail">Addresse e-mail</label>
                        <input v-model="email" type="email" class="form-control" name="email" id="signinSrEmail" placeholder="Addresse e-mail" aria-label="Addresse e-mail" required
                               data-msg="Veuillez entrer une adresse e-mail valide."
                               data-error-class="u-has-error"
                               data-success-class="u-has-success"
                        >
                    </div>
                    <!-- End Form Group -->

                    <!-- Form Group -->
                    <div class="js-form-message form-group">
                        <label class="form-label" for="signinSrPassword">Mot de passe</label>
                        <input v-model="password" type="password" class="form-control" name="password"
                               id="signinSrPassword" placeholder="********" aria-label="********" required
                               data-msg="Votre mot de passe est invalide. Veuillez réessayer"
                               data-error-class="u-has-error"
                               data-success-class="u-has-success">
                    </div>
                    <!-- End Form Group -->

                    <!-- Form Group -->
                    <div class="js-form-message form-group">
                        <label class="form-label" for="signinSrConfirmPassword">Mot de passe confirmation</label>
                        <input v-model="passwordConfirm" type="password" class="form-control" name="confirmPassword"
                               id="signinSrConfirmPassword" placeholder="********" aria-label="********" required
                               data-msg="Ce mot de passe ne correspond pas au mot de passe précédent."
                               data-error-class="u-has-error"
                               data-success-class="u-has-success">
                    </div>
                    <!-- End Form Group -->

                    <!-- Checkbox -->
                    <div class="js-form-message mb-5">
                        <div class="custom-control custom-checkbox d-flex align-items-center text-muted">
                            <input type="checkbox" class="custom-control-input" id="termsCheckbox"
                                   name="termsCheckbox" required
                                   data-msg="Veuillez lire et accepter nos Termes et Conditions."
                                   data-error-class="u-has-error"
                                   data-success-class="u-has-success">
                            <label class="custom-control-label" for="termsCheckbox">
                                <small>
                                    J'ai lu et approuvé
                                    <router-link class="link-muted" :to="{'name': 'terms'}">les Termes et Conditions</router-link>
                                </small>
                            </label>
                        </div>
                    </div>
                    <!-- End Checkbox -->

                    <!-- Submit Errors -->
                    <div class="mb-7">
                        <p v-if="error" class="text-danger">{{ error }}</p>
                    </div>
                    <!-- End Submit Errors -->

                    <!-- Button -->
                    <div class="row align-items-center mb-5">
                        <div class="col-5 col-sm-6">
                            <span class="small text-muted">Vous avez déjà un compte?</span>
                            <router-link class="small" :to="{'name': 'login'}">Se connecter</router-link>
                        </div>

                        <div class="col-7 col-sm-6 text-right">
                            <LoadingButton v-if="isRequestLoading"/>
                            <button v-else type="submit" class="btn btn-primary transition-3d-hover"
                                    v-bind:disabled="!isFormValid">S'inscrire</button>
                        </div>
                    </div>
                    <!-- End Button -->
                </form>
            </div>
            <!-- End Login Form -->
        </main>

        <a ref="openBasicModal" class="btn btn-sm btn-primary transition-3d-hover" href="#basicModal"
           data-modal-target="#basicModal" hidden>
            Open basic modal
        </a>
        <BasicModal :title="modal.title" :text="modal.text" :next="modal.next"/>

        <script type="application/javascript" v-bind:src="hsCoreSrc"></script>
        <script type="application/javascript" v-bind:src="hsModalWindowSrc"></script>
        <script type="application/javascript" v-bind:src="hsPluginsInitSrc"></script>
    </div>
</template>

<script>
    import {CREATE_USER} from "../../settings/graphql/index";
    import {JS_FILES} from "../../settings/scripts";
    import LoadingButton from "../../components/LoadingButton";
    import BasicModal from "../../components/BasicModal";
    import {errorMessageDisplay} from "../../xlib/graphql";

    export default {
        name: "SignUp",
        components: {LoadingButton, BasicModal},
        data() {
            return {
                email: "",
                password: "",
                passwordConfirm: "",
                error: null,
                isRequestLoading: false,
                modal: {
                    text: "",
                    title: "",
                    next: ""
                },
                hsCoreSrc: JS_FILES.hs.core,
                hsModalWindowSrc: JS_FILES.hs.modalWindow,
                hsPluginsInitSrc: JS_FILES.hs.pluginsInit.modalWindow
            };
        },
        computed: {
            isFormValid: function () {
                return this.password === this.passwordConfirm;
            }
        },
        methods: {
            submit_form(event) {
                event.preventDefault();
                this.$data.isRequestLoading = true;
                const { email, password } = this.$data;
                const accountActivationCallbackPath = "/account/activate";
                this.$apollo.mutate({
                    mutation: CREATE_USER,
                    variables: {email, password, accountActivationCallbackPath}
                }).then(() => {
                    // console.log(`User creation successful : ${data}`);
                    this.$data.isRequestLoading = false;
                    this.$data.modal = {
                        title: "Email envoyé",
                        text: `Nous vous avons envoyé un mail à l'adresse ${email}. Veuillez le consulter afin de
                               pouvoir activer votre compte`,
                        next: 'welcome'
                    };
                    this.$refs.openBasicModal.click();
                }).catch((error) => {
                    // console.error(`Error on user creation: ${JSON.stringify(error)}`);
                    this.$data.isRequestLoading = false;
                    this.$data.error = errorMessageDisplay(error);
                });
            }
        }
    }
</script>

<style scoped>

</style>